const catsAdoption = {
    "silver-blue": {
      name: "BLUE DAY",
      img:  "http://placekitten.com/200/300"
       
    },
    "jordan-bright": {
      name: "BRIGHTY",
      img:  "http://placekitten.com/g/200/300"
        
    },
    "Marky-light": {
      name: "MARKY",
      img: "http://placekitten.com/g/300/300"
        
    }
  };

  export default catsAdoption; 

  